import { useState } from 'react';
import { Smartphone, Share, X } from 'lucide-react';

const isStandalone = () =>
  typeof window !== 'undefined' &&
  (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true);
const isMobile = () => typeof window !== 'undefined' && /iphone|ipad|ipod|android/i.test(window.navigator.userAgent);
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

// Subtle inline nudge for first-time mobile users to install the PWA.
export default function HomeScreenHint() {
  const [hidden, setHidden] = useState(
    () => isStandalone() || !isMobile() || (typeof localStorage !== 'undefined' && localStorage.getItem('tm-homescreen-hint') === '1'),
  );
  if (hidden) return null;
  const dismiss = () => { try { localStorage.setItem('tm-homescreen-hint', '1'); } catch { /* ignore */ } setHidden(true); };
  return (
    <div data-testid="homescreen-hint" className="flex items-center gap-2 bg-slate-900 text-white text-xs px-3 py-2 mb-4 border-l-2 border-brand">
      <Smartphone size={15} className="text-brand shrink-0" />
      <span className="flex-1">
        Add <b>TradesMate</b> to your home screen{isIOS() ? <> — tap <Share size={12} className="inline text-brand" /> <b>Share</b> then <b>“Add to Home Screen”</b></> : ' for one-tap access, like an app'}.
      </span>
      <button data-testid="homescreen-hint-dismiss" onClick={dismiss} aria-label="Dismiss" className="text-slate-400 hover:text-white shrink-0"><X size={14} /></button>
    </div>
  );
}
